import React from "react";
import { Grid } from "@material-ui/core";
import numeral from "numeral";
import "./styles.css";

const CalculationRow = ({ text, amount, bold, companyPrimaryColor }) => {
  const boldClass = bold ? "net-cost-calc-amount-bold" : "net-cost-calc-amount-reg";
  const boldTextColor = bold ? companyPrimaryColor : "";

  return (
    <Grid container direction="row" item justify="space-around">
      <Grid xs={6} item><div className={boldClass} style={{ color: boldTextColor }}>{text}</div></Grid>
      <Grid xs={6} item><div className={`net-cost-calc-amount-display ${boldClass}`} style={{ color: boldTextColor }}>{amount}</div></Grid>
    </Grid>
  );
};

const NetCostSection = ({ companyPrimaryColor, prepaymentPenalty, interestSavings }) => (
  <Grid container item direction="column" style={{ marginTop: "2rem", fontFamily: "Work Sans" }}>
    <Grid item xs={12}><div className="net-cost-header" style={{ borderBottom: `1px dashed ${companyPrimaryColor}` }}>Net Cost to Refinance</div></Grid>
    <Grid container item direction="row">
      <Grid item xs={4} className="net-cost-text-section">
        If you take your
        <strong>prepayment penalty</strong>
        , then subtract the
        <strong>interest you save</strong>
        {" "}
        (versus your current loan amount through existing maturity), you get your net cost to refinance.
      </Grid>
      <Grid item xs={1} />
      <Grid container item xs={7} direction="column" className="net-cost-calcs-wrapper">
        <CalculationRow text="Prepay Penalty" amount={`${numeral(prepaymentPenalty).format("$0,0")}`} />
        <CalculationRow text="Interest Savings" amount={`(${numeral(interestSavings).format("$0,0")})`} />
        <div style={{ border: "1px solid #DADCE0" }} />
        <CalculationRow companyPrimaryColor={companyPrimaryColor} text="Net Cost to Refi" amount={`${numeral(prepaymentPenalty - interestSavings).format("$0,0")}`} bold />
      </Grid>
    </Grid>
  </Grid>
);

export default NetCostSection;
